// PowerSync — streak_state + user_activity_log.
//
// Local*-типы — РЕАЛЬНЫЕ колонки БД (information_schema):
//   streak_state: current_streak/longest_streak/last_activity_date (Phase 5)
//   user_activity_log: activity_date/activity_type/count/minutes (UNIQUE per
//     user/day/type — агрегаты считаются на клиенте через GROUP BY).
import { usePowerSyncQuery } from "@/lib/powersync/use-query";

export interface LocalStreakState {
	user_id: string;
	current_streak: number;
	longest_streak: number;
	last_activity_date: string | null;
	weekly_freeze_used: number; // bool
	total_active_days: number | null;
	last_finalized_date: string | null;
	freeze_balance: number | null;
	freezes_reset_at: string | null;
	auto_freeze_enabled: number | null; // bool
	daily_goal_minutes: number | null;
	nudge_hour_local: number | null;
	last_nudge_at: string | null;
	total_study_minutes: number | null;
	created_at: string;
	updated_at: string;
}

export interface LocalUserActivity {
	id: string;
	user_id: string;
	activity_date: string; // date
	activity_type: string;
	count: number | null;
	minutes: number | null;
	timezone: string | null;
	last_occurred_at: string | null;
	created_at: string;
	updated_at: string;
}

export function useStreakStateQuery(userId: string | undefined) {
	return usePowerSyncQuery<LocalStreakState>(`SELECT * FROM streak_state WHERE user_id = ?`, [
		userId ?? "",
	]);
}

export function useActivityLogQuery(userId: string | undefined, fromDate: string, toDate: string) {
	return usePowerSyncQuery<LocalUserActivity>(
		`SELECT * FROM user_activity_log
		   WHERE user_id = ?
		     AND activity_date >= ?
		     AND activity_date <= ?
		ORDER BY activity_date DESC`,
		[userId ?? "", fromDate, toDate],
	);
}
